export default "__VITE_PUBLIC_ASSET__968e7349__"